import { IBusinessForCustomerForecast, ICustomerForecast } from '../entities/businessForCustomerForecast';

/**
 * 客先内示のファクトリ
 */
export class CustomerForecastFactory {
  /**
   * 客先内示の初期データを生成
   * @param initialData - 初期データ
   */
  public static create = (initialData: Partial<ICustomerForecast> = {}): ICustomerForecast => {
    const customerForecast: Required<ICustomerForecast> = {
      customerForecastResponsibleUserIdHistory: initialData.customerForecastResponsibleUserIdHistory ?? '',
      createdSupplierForecast: initialData.createdSupplierForecast ?? false,
      receivedYear: initialData.receivedYear ?? 0,
      receivedMonth: initialData.receivedMonth ?? 0,
      targetYear: initialData.targetYear ?? 0,
      targetMonth: initialData.targetMonth ?? 0,
      amount: initialData.amount ?? 0,
      updateAt: initialData.updateAt ?? 0,
    };

    return customerForecast;
  };
}

/**
 * 客先内示の取引情報ファクトリ
 */
export class BusinessCustomerForecastFactory {
  /**
   * 客先内示の初期データを生成
   * @param initialData - 初期データ
   */
  public static create = (initialData: Partial<IBusinessForCustomerForecast> = {}): IBusinessForCustomerForecast => {
    const customerForecast: Required<IBusinessForCustomerForecast> = {
      businessId: initialData.businessId ?? '',
      aggregateBusinessId: initialData.aggregateBusinessId ?? '',
      baseBusinessResponsibleUsers: initialData.baseBusinessResponsibleUsers ?? [],
      receiptForecastName: initialData.receiptForecastName ?? '',
      supplierNumber: initialData.supplierNumber ?? '',
      supplierName: initialData.supplierName ?? '',
      businessNumber: initialData.businessNumber ?? '',
      businessName: initialData.businessName ?? '',
      package: initialData.package ?? '',
      unit: initialData.unit ?? '',
      manufacturer: initialData.manufacturer ?? '',
      warehouseNumber: initialData.warehouseNumber ?? '',
      warehouse: initialData.warehouse ?? '',
      customerNumber: initialData.customerNumber ?? '',
      customerName: initialData.customerName ?? '',
      salesDestinationNumber: initialData.salesDestinationNumber ?? '',
      salesDestinationName: initialData.salesDestinationName ?? '',
      endUser: initialData.endUser ?? '',
      salesUnitPrice: initialData.salesUnitPrice ?? undefined,
      createdSupplierForecast: initialData.createdSupplierForecast ?? false,
      forecastForReceiptName: initialData.forecastForReceiptName ?? '',
      forecastForReceiptResponsibleUsers: initialData.forecastForReceiptResponsibleUsers ?? [],
      customerForecasts: initialData.customerForecasts?.map((forecast) => CustomerForecastFactory.create(forecast)) ?? [],
    };

    return customerForecast;
  };
}
